import {
  CTA,
  styled,
} from '@volkswagen-onehub/components-core';
import React, {MouseEventHandler, useContext, useEffect} from 'react';
import {getLang, getTranslations} from '../../translations';
import {useFeatureServices} from '../../use-feature-services';
import {
  createConfiguration,
  createConstantData,
  createPartner,
  createProcess,
} from '../../utils/get-tracking-event-data';
import {LayerCloseHandle} from '../../types/layers';
import VKWrapper from '../VKWrapper';
import { LayerContext } from '../../Layers';
import { useDealersStore } from '../../utils/use-dealers-store';
import { VehicleData } from '../../types';

const MotoInsightsCTA = styled.a`
  text-decoration: none;
`;

interface Props {
  close: LayerCloseHandle;
  vehicle: VehicleData;
}

const BuildYourDealModal = ({close, vehicle}: Props) => {
  const {tracking} = useFeatureServices();
  const dealer = useDealersStore().getDealer(vehicle?.dealer_id);
  const lang = getLang();
  const trans = getTranslations();
  const {isLayerOpen} = useContext(LayerContext);

  useEffect(() => {
    if (isLayerOpen('motoinsight-layer')) {
      setTimeout(() => {
        window.MOTOINSIGHT.updateView(`${lang}-ca`);
      }, 500);
    }
  }, [isLayerOpen('motoinsight-layer')]);

  const handleClick = (e: React.SyntheticEvent<HTMLAnchorElement>) => {
    tracking.track('VWBasic_VehicleButton_Click', {
      ...createConstantData('VWBasic_VehicleButton_Click', vehicle.category),
      configuration: createConfiguration(
        'VWBasic_VehicleButton_Click',
        vehicle,
        lang
      ),
      partner: createPartner(dealer),
      process: createProcess('3'),
      link: {
        url: e.currentTarget.href,
        name: e.currentTarget.innerText.trim(),
      },
    });
  };

  return vehicle ? (
    <VKWrapper>
      <MotoInsightsCTA
        href="#"
        className="motocommerce-vehicle-link"
        data-mc-page="purchase"
        data-mc-medium="vdp"
        data-stock-id={!vehicle.in_production ? vehicle.vin : vehicle.stock_number}
        target="_new"
        onClick={(e) => handleClick(e)}
      >
        <CTA tag="button">{trans.details.motoinsights.continue}</CTA>
      </MotoInsightsCTA>

      <CTA
        tag="button"
        emphasis="tertiary"
        onClick={close as unknown as MouseEventHandler<HTMLButtonElement>}
      >
        {trans.details.motoinsights.cancel}
      </CTA>
    </VKWrapper>
  ) : null;
};

export default BuildYourDealModal;
